export const CUSTOM_FIELD_NOTE_MAX_LENGTH = 300;

export enum CustomFieldTypeEnum {
  Number = 'number',
  Text = 'text',
  Select = 'select'
}

// A business-level field definition (e.g. "עוצמת מכונת לייזר") — stored once on the
// business and shared by all of its customers; each customer stores their own value.
export interface ICustomFieldDefinition {
  id: string;
  label: string;
  type: CustomFieldTypeEnum;
  unit?: string; // number fields only, e.g. J/cm²
  options?: Array<string>; // select fields only
  trackHistory: boolean;
  // Removing a field only hides it — the customers' values stay in the DB so support
  // can still retrieve them. Hidden fields are never returned to the client.
  isHidden?: boolean;
  hiddenAt?: Date | string;
}

export interface ICustomFieldHistoryEntry {
  // Stable identifier of a single entry, used to edit or remove it. Optional because
  // entries recorded before per-entry editing existed have none — those are addressed
  // by their index and get an id backfilled on the next write.
  id?: string;
  value: string;
  // The date the value applies to. Defaults to "now" but can be back-dated manually.
  date: Date | string;
  note?: string;
  // When the entry was actually recorded — differs from `date` when it was back-dated.
  createdAt?: Date | string;
}

// A customer's value for one field. history is newest-first; when the definition
// does not track history it always holds a single entry (the current value).
export interface ICustomerCustomFieldValue {
  fieldId: string;
  history: Array<ICustomFieldHistoryEntry>;
}
